/**
 * Render component - links entity to Three.js objects
 */

import type * as THREE from 'three';

export interface RenderComponent {
  meshId: number;
  instanceIndex: number;
  visible: boolean;
  scale: number;
  color: THREE.Color | null;
}

export function createRender(instanceIndex: number = -1): RenderComponent {
  return {
    meshId: 0,
    instanceIndex,
    visible: true,
    scale: 1,
    color: null,
  };
}
